import { ChangeEvent, useMemo } from 'react';

type UseCharacterLimitProps = {
  maxLength?: number;
  value: string;
  onChange?: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
};

export function useCharacterLimit({
  maxLength,
  value,
  onChange,
}: UseCharacterLimitProps) {
  const characterCount = useMemo(() => {
    if (value === '') {
      return 0;
    }
    return value.length;
  }, [value]);

  const handleChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const newValue = e.target.value;
    if (maxLength === undefined || newValue.length <= maxLength) {
      onChange?.(e);
    }
  };

  return {
    value,
    characterCount,
    handleChange,
    maxLength,
  };
}
